export default __webpack_public_path__ + "static/BrandonGrotesque-ThinItalic-1e37b3360d1c648e07da9f1e21a98a8a.woff2";